const allDesks = (arrayOfDesks) => {
  return arrayOfDesks.reduce((result, current) => result + (current === 0.01 ? 0 : current));
};

export default allDesks;
